import { PourbackReason } from "@/pages/caster/models/catalogs/pourback-reasons";
import { EditAndDeleteButtons } from "@/pages/eaf/data-entry/components/tables/components/EditAndDeleteButtons";
import { Checkbox } from "@mui/material";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";

type Props = {
	onDeleteButtonClick: (pourbackReasonId: number) => void;
	onEditButtonClick: (pourbackReasonId: number) => void;
};

export const useTableData = ({
	onDeleteButtonClick,
	onEditButtonClick,
}: Props) => {
	const columns: ColDef[] = [
		{
			field: "PourbackReasonName",
			headerName: "Pourback Reason Name",
			minWidth: 63,
			flex: 4,
			wrapText: true,
			autoHeight: true,
		},
		{
			field: "IsActive",
			headerName: "Enabled",
			cellRenderer: (params: any) => {
				return <Checkbox checked={params.value} disabled={true} />;
			},
			flex: 4,
			minWidth: 86,
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
		},
		{
			field: "Actions",
			headerName: "",
			cellStyle: {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			},
			cellRenderer: EditAndDeleteButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				deleteItem: onDeleteButtonClick,
				edit: onEditButtonClick,
				id: (params.data as PourbackReason).PourbackReasonId,
			}),
			flex: 1,
			minWidth: 50,
		},
	];

	return { columns };
};
